module.exports = __webpack_public_path__ + "media/images/webpage/hotels/4460/floorguide/onesence-5-525fe159d57fde22bdc38444da8f95a9.webp";